<template>
  <!-- Panel lateral izquierdo, slide-in. Mismo lenguaje visual que LayersPanel/ConfigureSubdivisionsModal. -->
  <aside v-show="visible"
    class="absolute left-0 top-0 bottom-0 w-72 flex flex-col bg-white border-r border-[#E4E6EB] shadow-lg z-10">

    <!-- HEADER estilo Meta: título + close -->
    <header class="flex items-center justify-between px-4 py-3 border-b border-[#E4E6EB] bg-white">
      <h2 class="text-base font-semibold text-gray-900">
        {{ $t('views') }}
      </h2>

      <button
        @click="$emit('epc-close', true)"
        aria-label="Cerrar"
        class="w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 transition-colors duration-150">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"/>
        </svg>
      </button>
    </header>

    <!-- LISTA scrollable -->
    <div class="flex-1 overflow-y-auto px-2 py-2 bg-white">
      <ul v-if="views && views.length" class="space-y-1">
        <li v-for="view in views" :key="view.code">
          <button @click="$emit('view-selected', view.code)"
            class="w-full flex items-center gap-3 px-3 py-2 rounded text-left text-sm transition-colors duration-150"
            :class="activeView === view.code
              ? 'bg-blue-50 text-blue-700 border border-blue-200 font-medium'
              : 'text-gray-700 hover:bg-gray-50 border border-transparent'">
            <b-icon pack="fas" :icon="view.icon || 'grip-horizontal'" size="is-small" />
            <span class="truncate">{{ view.name }}</span>
          </button>
        </li>
      </ul>

      <!-- Empty state (no debería verse — el botón del subheader está disabled hasta procesar) -->
      <p v-else class="text-sm text-gray-400 text-center py-6">
        {{ $t('no_layers_to_display') }}
      </p>
    </div>
  </aside>
</template>

<script>
export default {
  name: "ViewerPanelViews",

  props: {
    // [{code, name, icon}] — derivado en el padre a partir de _GetLayers() + "all"
    views:      { type: Array,   default: () => [] },
    // Código de la vista activa actualmente
    activeView: { type: String,  default: 'all' },
    // Controla v-show desde el padre
    visible:    { type: Boolean, default: false },
  },
}
</script>
